'use strict';
import React from 'react';
import jpSetAction from '../actions/jpSetAction';
import jpSetStore from '../stores/jpSetStore';
import SideMenu from '../components/sideMenu';
import NavBar from '../components/navBar';
import menuAction from '../actions/menuAction';
import Loading from '../components/loading';
import EmailModal from './jpSetComponents/emailModal';

class JourneySetting extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.removeEmail = this.removeEmail.bind(this);
        this.addEmail = this.addEmail.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);

        this.state = {
            processing: jpSetStore.getState().processing,
            conversionRate: jpSetStore.getState().conversionRate,
            emails: jpSetStore.getState().emails,
            modalClose: false,
        };
    }
    componentDidMount() {
        jpSetStore.listen(this.onChange);
        menuAction.pageNumber(9);
        if (!this.state.processing) {
            jpSetAction.processing(true);
            jpSetAction.getConversion();
        }
    }
    componentWillUnmount() {
        jpSetStore.unlisten(this.onChange);
    }
    onChange(state) {
        this.setState({
            conversionRate: state.conversionRate,
            emails: state.emails,
            processing: state.processing
        });
    }
    shouldModalClose(data){
        this.setState({
            modalClose: data
        });
    }
    handleChange(e) {
        let conversionRate = parseFloat(e.target.value);

        jpSetAction.conversionRate(conversionRate);
    }
    removeEmail(e){
        let index = parseInt(e.target.getAttribute('data-index'));
        jpSetAction.removeEmail(index);
    }
    addEmail(){
        this.setState({modalClose: true});
    }
    handleClick(e) {
        if (this.state.processing) return;

        jpSetAction.processing(true);
        jpSetAction.updateJourneySetting(this.state.conversionRate, this.state.emails);
    }
    renderEmails() {
        let emails = this.state.emails.map((email, index) => {
            return (
                <li className="list-group-item" key={index} >
                    <div className="jps-em">{email}</div>
                    <div className="jps-rev glyphicon glyphicon-remove" data-index={index} onClick={this.removeEmail}></div>
                </li>
            );
        });

        return (
            <ul className="list-group">
                {emails}
            </ul>
        )
    }
    render() {
        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props} />
                    <SideMenu {...this.props} />
                    <div className=" col-md-10  col-sm-8 us-form">
                        <div className="row">

                            <div className="col-sm-3">
                                <div className="atd-hd">
                                    <h4><b>Journey Planner Management</b></h4>
                                </div>
                                <br />

                                <form className="atd-i-wp">
                                    <label htmlFor="conversionRate" className="control-label">Conversion Rate (SGD/km):</label>

                                    <input type="number" className="form-control" id="conversionRate"
                                        value={this.state.conversionRate} onChange={this.handleChange} />

                                </form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-3">
                                <div>
                                    <label htmlFor="emails" className="control-label">Email Groups:</label>
                                    <button className="btn btn-default btn-xs jps-add " onClick={this.addEmail}>Add</button>
                                </div>
                                <small>Users to receive notification when claims approved </small>
                                {this.renderEmails()}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-3">
                                <button className="btn btn-warning" onClick={this.handleClick}>Save</button>
                            </div>
                        </div>
                    </div>

                </div>
                <EmailModal modalClose={this.state.modalClose} shouldModalClose={this.shouldModalClose} />
                <Loading processing={this.state.processing} />
            </div>
        )
    }

}
export default JourneySetting;


// WEBPACK FOOTER //
// ./app/setComponents/journeySetting.js